"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomForm = void 0;
const mithril_1 = __importDefault(require("mithril"));
const room_1 = require("../../../model/room");
const venue_1 = require("../../../model/venue");
const form_for_1 = require("../../../widgets/form_for");
const modal_1 = require("../../../widgets/modal");
const notification_center_1 = require("../../../widgets/notification_center");
const right_panel_1 = require("../../../widgets/right_panel");
const room_table_1 = require("./room_table");
let venueList = [];
function mapVenues() {
    return venueList.map(v => [v.id, v.name]);
}
function renderForm(form) {
    return [
        form.errorBlock(),
        form.selectField("Centre opérationnel", "venue_id", mapVenues()),
        form.field("Services", "available_hardware", "text", {
            renderValue: (x) => {
                return x ? x.join(", ") : [];
            },
            transformValue: (x) => {
                return x.split(/[ ]*,[ ]*/);
            }
        }),
        form.field("Nom", "name", "text"),
        form.checkbox("Actif", "active")
    ];
}
exports.RoomForm = {
    room: {},
    active: false,
    reset() {
        this.room = {
            active: true,
            name: "",
        };
    },
    show(room) {
        (0, venue_1.listVenues)().then(function (x) { venueList = x; });
        if (room) {
            this.room = room;
            if (room.id) {
                // Reload the contract
                room_1.RoomProvider.show(this.room.id).then((room) => {
                    this.room = room;
                    //
                });
            }
        }
        else {
            this.reset();
        }
        this.active = true;
    },
    title() {
        if (this.room.id !== undefined) {
            return `Editer salle ${this.room.name}`;
        }
        else {
            return `Nouvelle salle`;
        }
    },
    view(_vnode) {
        let form = (0, form_for_1.formFor)(this.room, room_1.RoomProvider, (form) => {
            return (0, modal_1.modalCard)({
                title: this.title(),
                content: renderForm(form),
                foot: (0, mithril_1.default)("div", { class: "is-pulled-right" }, form.submit("Envoyer", {
                    onsubmit: (obj) => {
                        if (this.room.id === undefined) {
                            notification_center_1.Notification.success(`La salle ${obj.name} a bien été créée.`, (0, mithril_1.default)("a", { href: "#", onclick: () => { right_panel_1.RightPanel.open("rooms", obj.id, "show"); } }, "Afficher"));
                        }
                        else {
                            notification_center_1.Notification.success(`La salle ${obj.name} a bien été mise à jour.`, (0, mithril_1.default)("a", { href: "#", onclick: () => { right_panel_1.RightPanel.open("rooms", obj.id, "show"); } }, "Afficher"));
                        }
                        room_table_1.RoomTable.fetch();
                        exports.RoomForm.active = false;
                    }
                })),
                isActive: exports.RoomForm.active,
                onClose: () => { exports.RoomForm.active = false; }
            });
        });
        return form;
    }
};
exports.RoomForm.reset();
